import React, { useEffect, useRef, useState } from "react";
import { SkinViewer, IdleAnimation } from "skinview3d";
import Modal from './Modal';
import './Listmember.css';

const Listmember = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const viewerContainerRef = useRef(null);

  const members = [
    { name: 'DrDeath9867', skin: '/skin/DrDeath9867.png', info: 'OG', desk: 'Pendiri atau orang pertama dalam keluarga ini memiliki peran yang sangat penting. Dia adalah orang yang memulai segalanya dan membangun fondasi bagi generasi berikutnya. Tanpa keberadaan mereka, keluarga ini mungkin tidak akan ada seperti sekarang.' },
    { name: 'JagungRebus', skin: '/skin/JagungRebus.png', info: 'Real OG', desk: 'Pendiri atau orang pertama dalam keluarga ini memiliki peran yang sangat penting. Dia adalah orang yang memulai segalanya dan membangun fondasi bagi generasi berikutnya. Tanpa keberadaan mereka, keluarga ini mungkin tidak akan ada seperti sekarang.' },
    { name: 'Beduu24', skin: '/skin/Beduu24.png', info: 'Real OG', desk: 'Pendiri atau orang pertama dalam keluarga ini memiliki peran yang sangat penting. Dia adalah orang yang memulai segalanya dan membangun fondasi bagi generasi berikutnya. Tanpa keberadaan mereka, keluarga ini mungkin tidak akan ada seperti sekarang.' },
    { name: 'xeapers', skin: '/skin/xeapers.png', info: 'Real OG', desk: 'Pendiri atau orang pertama dalam keluarga ini memiliki peran yang sangat penting. Dia adalah orang yang memulai segalanya dan membangun fondasi bagi generasi berikutnya. Tanpa keberadaan mereka, keluarga ini mungkin tidak akan ada seperti sekarang.' },
    { name: 'YuwaGG', skin: '/skin/YuwaGG.png', info: 'Real OG', desk: 'Pendiri atau orang pertama dalam keluarga ini memiliki peran yang sangat penting. Dia adalah orang yang memulai segalanya dan membangun fondasi bagi generasi berikutnya. Tanpa keberadaan mereka, keluarga ini mungkin tidak akan ada seperti sekarang.' },
    { name: 'Naa5500', skin: '/skin/Naa5500.png', info: 'Real OG', desk: 'Orang kedua dalam keluarga ini memiliki peran yang tak kalah penting. Dia melanjutkan dan mengembangkan apa yang telah dimulai oleh pendiri keluarga. Dengan kontribusinya, keluarga ini semakin tumbuh dan berkembang hingga mencapai keadaan yang lebih baik.' },
    { name: 'MinecraftZ01', skin: '/skin/MinecraftZ01.png', info: 'Real OG', desk: 'Pendiri atau orang pertama dalam keluarga ini memiliki peran yang sangat penting. Dia adalah orang yang memulai segalanya dan membangun fondasi bagi generasi berikutnya. Tanpa keberadaan mereka, keluarga ini mungkin tidak akan ada seperti sekarang.' },
    { name: 'MeSalsaa', skin: '/skin/MeSalsaa.png', info: 'TFH', desk: 'Anggota keluarga biasa ini turut berperan dalam menjaga dan mempererat ikatan keluarga. Mereka memberikan dukungan, kasih sayang, dan kontribusi dalam kehidupan sehari-hari. Meskipun mungkin tidak selalu terlihat, keberadaan mereka sangat berarti dalam menjaga keharmonisan dan kesejahteraan keluarga.' },
    { name: 'MilaChan300', skin: '/skin/MilaChan300.png', info: 'TFH', desk: 'Anggota keluarga biasa ini turut berperan dalam menjaga dan mempererat ikatan keluarga. Mereka memberikan dukungan, kasih sayang, dan kontribusi dalam kehidupan sehari-hari. Meskipun mungkin tidak selalu terlihat, keberadaan mereka sangat berarti dalam menjaga keharmonisan dan kesejahteraan keluarga.' },
    { name: 'AISYAAAARAIHNAA', skin: '/skin/AISYAAAARAIHNAA.png', info: 'TFH', desk: 'Anggota keluarga biasa ini turut berperan dalam menjaga dan mempererat ikatan keluarga. Mereka memberikan dukungan, kasih sayang, dan kontribusi dalam kehidupan sehari-hari. Meskipun mungkin tidak selalu terlihat, keberadaan mereka sangat berarti dalam menjaga keharmonisan dan kesejahteraan keluarga.' },
    { name: 'Asepp771', skin: '/skin/Asepp771.png', info: 'TFH', desk: 'Anggota keluarga biasa ini turut berperan dalam menjaga dan mempererat ikatan keluarga. Mereka memberikan dukungan, kasih sayang, dan kontribusi dalam kehidupan sehari-hari. Meskipun mungkin tidak selalu terlihat, keberadaan mereka sangat berarti dalam menjaga keharmonisan dan kesejahteraan keluarga.' },
    { name: 'KangAjay', skin: '/skin/KangAjay.png', info: 'TFH', desk: 'Anggota keluarga biasa ini turut berperan dalam menjaga dan mempererat ikatan keluarga. Mereka memberikan dukungan, kasih sayang, dan kontribusi dalam kehidupan sehari-hari. Meskipun mungkin tidak selalu terlihat, keberadaan mereka sangat berarti dalam menjaga keharmonisan dan kesejahteraan keluarga.' },
    { name: 'Tiff3068', skin: '/skin/Tiff3068.png', info: 'TFH', desk: 'Anggota keluarga biasa ini turut berperan dalam menjaga dan mempererat ikatan keluarga. Mereka memberikan dukungan, kasih sayang, dan kontribusi dalam kehidupan sehari-hari. Meskipun mungkin tidak selalu terlihat, keberadaan mereka sangat berarti dalam menjaga keharmonisan dan kesejahteraan keluarga.' },
    { name: 'MasBuildersz', skin: '/skin/MazBuilders.png', info: 'TFH', desk: 'Anggota keluarga biasa ini turut berperan dalam menjaga dan mempererat ikatan keluarga. Mereka memberikan dukungan, kasih sayang, dan kontribusi dalam kehidupan sehari-hari. Meskipun mungkin tidak selalu terlihat, keberadaan mereka sangat berarti dalam menjaga keharmonisan dan kesejahteraan keluarga.' },
  ];

  const openModal = (member) => {
    setSelectedMember(member);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMember(null);
  };

  useEffect(() => {
    if (isModalOpen && selectedMember && viewerContainerRef.current) {
      const viewer = new SkinViewer({
        canvas: viewerContainerRef.current,
        width: 300,
        height: 400,
      });

      viewer.loadSkin(selectedMember.skin);
      viewer.autoRotate = true;

      const idleAnimation = new IdleAnimation();
      idleAnimation.speed = 3;
      viewer.animation = idleAnimation;

      return () => {
        viewer.dispose();
      };
    }
  }, [isModalOpen, selectedMember]);

  useEffect(() => {
    const disableRightClick = (e) => e.preventDefault();
    const disableCopyCut = (e) => e.preventDefault();

    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("copy", disableCopyCut);
    document.addEventListener("cut", disableCopyCut);
    document.addEventListener("dragstart", disableRightClick);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("copy", disableCopyCut);
      document.removeEventListener("cut", disableCopyCut);
      document.removeEventListener("dragstart", disableRightClick);
    };
  }, []);

  return (
    <div className="member-section">
      <h2 className="member-title">MEMBER<br />THE FAMILY HAVEN</h2>
      <div className="member-list">
        {members.map((member, index) => (
          <div
            key={index}
            className="member-item"
            onClick={() => openModal(member)}
          >
            {member.name}
          </div>
        ))}
      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <h3 className="modal-head">{selectedMember ? selectedMember.name : ''}</h3>
        <canvas ref={viewerContainerRef} width="300" height="400" />
        <p className="modal-info">{selectedMember ? selectedMember.info : ''}</p>
        <p className="modal-desk">{selectedMember ? selectedMember.desk : ''}</p>
      </Modal>
    </div>
  );
};

export default Listmember;
